import React, { useRef, useState } from "react";
import Loader from "../../components/Loader";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import AdminNav from "./AdminNav";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
const AddBank = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [accountNumber, setAccountNumber] = useState(Array(10).fill(""));
  const [sortCode, setSortCode] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankAddress, setBankAddress] = useState("");
  const [iban, setIban] = useState("");
  const [swiftCode, setSwiftCode] = useState("");
  const inputRefs = useRef([]);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const token = localStorage.getItem("admintoken");

  const handleChange = (index, value) => {
    const newAccountNumber = [...accountNumber];

    // Ensure only one character is accepted per box
    if (value.length <= 1) {
      newAccountNumber[index] = value;
      setAccountNumber(newAccountNumber);

      // Move to the next box if valid input is added
      if (value) {
        if (index === newAccountNumber.length - 1) {
          // Add a new box dynamically if we're on the last one
          newAccountNumber.push("");
          setAccountNumber(newAccountNumber);

          // Allow React to render the new box, then focus
          setTimeout(() => {
            inputRefs.current[index + 1]?.focus();
          }, 0);
        } else {
          // Otherwise, just move to the next box
          inputRefs.current[index + 1]?.focus();
        }
      }
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace to move focus back
    if (e.key === "Backspace" && !accountNumber[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleInputChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, ""); // Allow only digits
    if (value.length > 6) value = value.slice(0, 6); // Restrict max length to 6

    // Automatically add dashes after every 2 characters
    const formattedValue =
      value
        .match(/.{1,2}/g) // Split into chunks of 2 characters
        ?.join("-") || ""; // Join chunks with a dash

    setSortCode(formattedValue);
  };
  const handleInputSwift = (e) => {
    let value = e.target.value.replace(/[^a-zA-Z0-9]/g, ""); // Allow only alphanumeric characters
    value = value.toUpperCase(); // Convert to uppercase
    if (value.length > 11) value = value.slice(0, 11); // Restrict length to 11 characters

    // Format the input as "AAAA-BB-CC-123"
    const formattedValue = value.replace(
      /^(.{4})(.{2})?(.*)$/,
      (_, part1, part2, part3) => {
        return `${part1 || ""}${part2 ? `-${part2}` : ""}${
          part3 ? `-${part3.slice(0, 2)}` : ""
        }${part3?.length > 2 ? `-${part3.slice(2)}` : ""}`;
      }
    );

    setSwiftCode(formattedValue);
  };

  const handleAddBank = async (e) => {
    e.preventDefault(); // Prevent page reload

    // Combine the account number digits into a single string
    const formattedAccountNumber = accountNumber.join("");

    // Validate required fields (optional but recommended)
    if (!formattedAccountNumber) {
      toast.error("Account Number is Required !");
      return;
    }

    const bankData = {
      userId: id, // Use the user ID from the URL
      accountNumber: formattedAccountNumber,
      sortCode,
      bankName,
      bankAddress,
      iban,
      swiftCode,
    };

    try {
      setLoading(true); // Show loader
      const res = await axios.post(
        `${process.env.REACT_APP_API}/api/v1/bank/add-bank`,
        bankData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token if required
          },
        }
      );

      setLoading(false); // Hide loader
      if (res.data.success) {
        toast.success(res.data.message);
        setAccountNumber(Array(10).fill(""));
        setSortCode("");
        setBankName("");
        setBankAddress("");
        setIban("");
        setSwiftCode("");
        navigate(`/dashboard/admin/user-details/${id}`);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred!");
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="wrapper d-flex align-items-stretch">
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2">
          <button
            type="button"
            id="openSidebar"
            onClick={toggleSidebar}
            className="bars-btn"
          >
            <FaBarsStaggered />
          </button>
          <AdminNav />
          <div className="add-bank-sec">
            <h1 className="text-center mb-5">Add New Bank Details</h1>
            <div className="add-bank-sub">
              <form onSubmit={handleAddBank}>
                <div className="add-bank-card w-100">
                  <h5>Account Number</h5>
                  <div className="account-boxes">
                    {accountNumber.map((digit, index) => (
                      <input
                        key={index}
                        ref={(el) => (inputRefs.current[index] = el)}
                        type="text"
                        className="account-inp"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                      />
                    ))}
                  </div>
                </div>

                <div className="add-bank-card w-100">
                  <h5>Sort Code</h5>
                  <input
                    type="text"
                    className="add-bank-input"
                    value={sortCode}
                    onChange={handleInputChange}
                    maxLength={8} // Includes dashes (e.g., "12-34-56")
                    placeholder="XX-XX-XX"
                  />
                </div>
                <div className="add-bank-card w-100">
                  <h5>Bank Name</h5>
                  <input
                    type="text"
                    className="add-bank-input"
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)}
                    placeholder="Enter Bank Name"
                  />
                </div>
                <div className="add-bank-card w-100">
                  <h5>Bank Address</h5>
                  <textarea
                    className="add-bank-input"
                    value={bankAddress}
                    onChange={(e) => setBankAddress(e.target.value)}
                    placeholder="Enter Bank  Address"
                  />
                </div>
                <div className="add-bank-card w-100">
                  <h5>IBAN</h5>
                  <input
                    className="add-bank-input"
                    value={iban}
                    onChange={(e) => setIban(e.target.value)}
                    placeholder="AA12BBBB34567891234567"
                    maxLength={22}
                    minLength={22}
                  />
                </div>
                <div className="add-bank-card w-100">
                  <h5>SWIFT/BIC</h5>
                  <input
                    type="text"
                    className="add-bank-input"
                    value={swiftCode}
                    onChange={handleInputSwift}
                    maxLength={15} // Includes dashes
                    placeholder="AAAA-BB-CC-123"
                  />
                </div>
                <button className="btn btn-lg btn-primary" type="submit">
                  Add New Bank
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBank;
